import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '首页',
      component: resolve => require(['@/components/index'], resolve)
    },
    {
      path: '/zongshu',
      name: '研究综述',
      component: resolve => require(['@/components/zongshu'], resolve)
    },
    {
      path: '/global50',
      name: '50强榜单',
      component: resolve => require(['@/components/global50'], resolve)
    },
    {
      path: '/profit',
      name: '利润排行',
      component: resolve => require(['@/components/profit'], resolve)
    },
    {
      path: '/industry',
      name: '细分领域',
      component: resolve => require(['@/components/industry'], resolve)
    },
    {
      path: '/potential',
      name: '潜力企业',
      component: resolve => require(['@/components/potential'], resolve)
    },
    {
      path: '/download',
      name: '榜单与报告下载',
      component: resolve => require(['@/components/download'], resolve)
    },
    {
      path: '/company/:name',
      name: '公司详情',
      component: resolve => require(['@/components/company'], resolve)
    }, 
    {
      path: '/sources',
      name: '研究方法',
      component: resolve => require(['@/components/sources'], resolve)
    }, {
      path: '/copyright',
      name: '版权声明',
      component: resolve => require(['@/components/copyright'], resolve)
    }, {
      path: '/organization',
      name: '组织机构',
      component: resolve => require(['@/components/organization'], resolve)
    }, {
      path: '/contact',
      name: '联系我们',
      component: resolve => require(['@/components/contact'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js